/* eslint-disable jsx-a11y/anchor-is-valid */
import {Tab, TabList, TabPanel, Tabs} from 'react-tabs'
import {KTableProvider} from '../../../../../../contexts/KTableProvider'
import {useHoteleria} from '../../../../../../hooks/useHoteleria'
import {TabModel} from '../../../../../../models'

import {SnackbarProvider} from 'notistack'
import ButtonClose from '../../../../../../components/UI/Button/IconButton'
import {FormRePrintCO} from '../Forms/FormRePrintCO'

const TableCheckOutProductsWrapper = () => {
  const {currentTabItem, changeCurrentTabItem} = useHoteleria()
  const handleBack = () => {
    const obj: TabModel = {
      ...currentTabItem,
      showPanel: false,
    }
    changeCurrentTabItem(obj)
  }
  let isDisabled = currentTabItem.idToEdit ? true : false

  return (
    <KTableProvider>
      <div className='sdx_content_tab_panel'>
        {isDisabled && <ButtonClose onClick={handleBack} color='#283897' />}
        <Tabs className={'sdx_sub_react_tab_panel '}>
          <TabList className={'sdx_sub_tab_panel p-0'}>
            <Tab className={'sdx_sub_tab_panel_option'}>ReImprimir</Tab>
          </TabList>
          <TabPanel>
            <FormRePrintCO />
          </TabPanel>
        </Tabs>
      </div>
      <SnackbarProvider />
    </KTableProvider>
  )
}

export {TableCheckOutProductsWrapper}
